import { getWindowSize, isMobile } from "../utils/window-utilities";

// Return the top corner x, y positions as a multiplier of window size
export const getPagePos = page => {
  const positions = {
    Home: [0, 0],
    About: [1.2, -1],
    Clients: [0.8, -2],
    Tech: [1.6, 0.5],
    Showcase: [2.6, 0.8],
    Demos: [0.4, 1.2],
    Contact: [0, -1],
  };

  return positions[page];
};

// Set body to a new x, y position via left & top
// (CSS has body transition settings to animate slide)
export const scrollPage = (left, top) => {
  document.body.style.left = left + "px";
  document.body.style.top = top + "px";
};

// Get window size using the new utility function
export const getWinSize = () => {
  return getWindowSize();
};

// Cache the container reference to avoid repeated DOM queries
let containerCache;
const getContainer = () => {
  if (!containerCache) {
    containerCache = document.querySelector(".scrollableExamples");
  }
  return containerCache;
};

export const goPage = page => {
  const [width, height] = getWinSize();
  const [posX, posY] = getPagePos(page);
  scrollPage(Math.round(-width * posX), Math.round(-height * posY));

  // Use requestAnimationFrame to avoid layout thrashing
  requestAnimationFrame(() => {
    const container = getContainer();
    if (!container) return;

    if (page !== "Demos") {
      container.style.position = "relative";
    } else if (isMobile()) {
      setTimeout(() => {
        container.style.position = "fixed";
      }, 600);
    }
  });
};
